export default __webpack_public_path__ + "static/men-bodymap-face-3a891acd29c99c70a1c6175d211189fa.webp";